import { render, staticRenderFns } from "./CardRow.vue?vue&type=template&id=2eb48d96&scoped=true"
import script from "./CardRow.vue?vue&type=script&lang=js"
export * from "./CardRow.vue?vue&type=script&lang=js"
import style0 from "./CardRow.vue?vue&type=style&index=0&id=2eb48d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb48d96",
  null
  
)

export default component.exports